import { Table, TableContainer } from '@ui-components/neo.tax';
import { Column, useRowSelect, UseRowSelectState } from 'react-table';

import { AscProject } from '@neo.tax/shared/graphql';

import { customCellClassNames } from './projects-table.styled';

const featureHooks = [useRowSelect];

export interface StringIdentifiable {
  id: string;
}

export type ProjectsTableProps<T extends object & { id: string }> = {
  data: T[];
  selectedProjectId?: string;
  selectedRowIds: string[];
  columns: Column<T>[];
  loadMoreItems: () => Promise<void>;
  loadingRows: boolean;
  loadingFooter: boolean;
};

export const ProjectsTable = <T extends object & { id: string }>({
  columns,
  data,
  loadMoreItems,
  loadingFooter,
  loadingRows,
  selectedProjectId,
}: ProjectsTableProps<T>): React.ReactElement => (
  <TableContainer>
    <Table<T>
      columns={columns}
      data={data}
      isFooterLoading={loadingFooter}
      isBodyLoading={loadingRows}
      featureHooks={featureHooks}
      customCellClassNames={[customCellClassNames<T>]}
      initialState={
        selectedProjectId
          ? ({
              selectedRowIds: {
                [selectedProjectId]: true,
              },
              // The types for `selectedRowIds` in `@types/react-table` are
              // *wrong*: They expect the keys to be of type `IdType<D>`, but
              // that's the type of a *property name* in the row object, not
              // the type of an *ID value*. The type of an ID value is always
              // `string`.
            } as UseRowSelectState<AscProject>)
          : {}
      }
      tableOptions={{
        getRowId: (row) => row.id,
      }}
      endReached={loadMoreItems}
    />
  </TableContainer>
);
